import format from "date-fns/format";
import { constants } from "../constants";

export function getTeamsDateFormat(date: Date) {
    return format(date, constants.dateFormat);
}

export function getTeamsTimeFormat(date: Date) {
    return format(date, constants.timeFormat);
}
